/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import { makeStyles } from '@mui/styles';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import clsx from 'clsx';
import parse from 'html-react-parser';

const useStyles = makeStyles({
  root: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
    top: '-1px',
    pointerEvents: 'auto',
  },
  icon: {
    borderRadius: '100px',
    width: 24,
    height: 24,
    boxShadow:
      'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: '#fffff !important',
    backgroundImage:
      'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',

    'input:hover ~ &': {
      backgroundColor: '#D1E9FF',
      border: '1px solid #1d6460',
      borderRadius: '100px',
      boxShadow: 'none',
    },
    'input:focus ~ &': {
      backgroundColor: '#FFFF',
      border: '1px solid #76767A',
      borderRadius: '100px',
      boxShadow: 'none',
    },
    'input:hover:focus ~ &': {
      backgroundColor: '#D1E9FF !important',
      border: '1px solid #1d6460 !important',
      borderRadius: '100px',
      boxShadow: 'none',
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background: 'rgba(206,217,224,.5)',
    },
    'input:checked ~ &': {
      border: '1px solid #1d6460 !important',
    },

    'input:active ~ &': {
      backgroundColor: '#FFFFF',
      border: '1px solid #1d6460',
      borderRadius: '100px',
      boxShadow: 'none',
    },
  },
  checkedIcon: {
    backgroundColor: '#ffff',
    backgroundImage:
      'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
      display: 'block',
      width: 24,
      height: 24,
      backgroundImage: 'radial-gradient(#1D6460,#1D6460 48%,transparent 54%)',
      content: '""',
    },
    border: '1px solid #1D6460',
    'input:focus:checked ~ &': {
      '&:before': {
        display: 'block',
        width: 24,
        height: 24,
        backgroundImage: 'radial-gradient(#1d6460,#1d6460 48%,transparent 54%)',
        content: '""',
      },
      backgroundColor: '#FFFF',
      border: '1px solid #76767A',
      borderRadius: '100px',
      boxShadow: 'none',
    },
    'input:hover:focus:checked ~ &': {
      '&:before': {
        display: 'block',
        width: 24,
        height: 24,
        backgroundImage: 'radial-gradient(#1d6460,#1d6460 48%,transparent 54%)',
        content: '""',
      },
      backgroundColor: '#D1E9FF !important',
      border: '1px solid #1d6460 !important',
      borderRadius: '100px',
      boxShadow: 'none',
    },
    'input:hover:checked ~ &': {
      '&:before': {
        display: 'block',
        width: 24,
        height: 24,
        backgroundImage: 'radial-gradient(#1d6460,#1d6460 48%,transparent 54%)',
        content: '""',
      },
      backgroundColor: '#D1E9FF',
      border: '1px solid #1d6460',
      borderRadius: '100px',
      boxShadow: 'none',
    },
    'input:active:checked ~ &': {
      '&:before': {
        display: 'block',
        width: 24,
        height: 24,
        backgroundImage: 'radial-gradient(#1d6460,#1d6460 48%,transparent 54%)',
        content: '""',
      },
      backgroundColor: '#FFFFF',
      border: '1px solid #1d6460',
      borderRadius: '100px',
      boxShadow: 'none',
    },
    'input:focus:active:checked ~ &': {
      '&:before': {
        display: 'block',
        width: 24,
        height: 24,
        backgroundImage: 'radial-gradient(#1d6460,#1d6460 48%,transparent 54%)',
        content: '""',
      },
      backgroundColor: '#FFFFF',
      border: '1px solid #1d6460',
      borderRadius: '100px',
      boxShadow: 'none',
    },
    'input:checked ~ &': {
      border: '1px solid #1D6460 !important',
      boxShadow: 'none',
    },
  },
  checked: {
    '&, & + $label': {
      color: 'black',
    },
  },
  descriptor: {
    display: 'flex',
  },
  description: {
    display: 'flex',
    whiteSpace: 'nowrap',
  },
  descriptorContainer: {
    display: 'flex',
  },
  dash: {
    display: 'flex',
    whiteSpace: 'pre',
  },
});
export const RadioButton = ({
  value,
  handleRadioChange,
  groupValue,
  showDescriptor,
  rowAlign,
  groupStyle,
  labelStyle,
}) => {
  const classes = useStyles();
  return (
    <Box className="paramContainer mobParamContainer">
      <RadioGroup
        aria-label="WTG"
        name="WTG"
        value={value}
        onChange={handleRadioChange}
        row={rowAlign}
        style={groupStyle}
      >
        {groupValue
          .sort((a, b) => a.sortPriority - b.sortPriority)
          .map((row) => (
            <FormControlLabel
              value={row.parameterCode}
              sx={{
                display: 'flex',
                alignItems: 'flex-start',
              }}
              control={
                <Radio
                  key={row.parameterCode}
                  className={classes.root}
                  disableRipple
                  disableFocusRipple
                  checkedIcon={
                    <span className={clsx(classes.icon, classes.checkedIcon)} />
                  }
                  classes={{ checked: classes.checked }}
                  icon={<span className={classes.icon} />}
                />
              }
              label={
                <div
                  className={classes.descriptorContainer}
                  style={{ marginTop: 6 }}
                >
                  <div className={classes.description}>
                    <b>{row.parameterDesc}&nbsp;</b>
                  </div>
                  <div className={classes.descriptor}>
                    <div className={classes.dash}>
                      {showDescriptor &&
                        row.parameterDescriptor !== '' &&
                        ` - `}
                    </div>
                    <div>
                      {showDescriptor &&
                        row.parameterDescriptor !== '' &&
                        parse(row.parameterDescriptor || '')}
                    </div>
                  </div>
                </div>
              }
              style={labelStyle}
            />
          ))}
      </RadioGroup>
    </Box>
  );
};

RadioButton.defaultProps = {
  showDescriptor: true,
  rowAlign: false,
  groupStyle: {
    width: '100%',
  },
  labelStyle: {
    padding: '12px 0',
    maxWidth: '100%',
    minWidth: '40%',
    color: '#656569',
    pointerEvents: 'none',
  },
};
RadioButton.propTypes = {
  value: PropTypes.string.isRequired,
  handleRadioChange: PropTypes.func.isRequired,
  groupValue: PropTypes.arrayOf.isRequired,
  showDescriptor: PropTypes.bool,
  rowAlign: PropTypes.bool,
  groupStyle: PropTypes.objectOf(PropTypes.string.isRequired),
  labelStyle: PropTypes.objectOf(PropTypes.string.isRequired),
};
export default RadioButton;
